module.exports = __webpack_public_path__ + "static/media/coperto-scoperto_campo.413ca6ad.svg";